import Tq1 from "./steps/tq1";
import Tq2 from "./steps/tq2";
import Tq3 from "./steps/tq3";
import Tq4 from "./steps/tq4";
import Tq5 from "./steps/tq5";
import Tq6 from "./steps/tq6";
import TqClaim from "./steps/tqClaim";
import TqAddDriver from "./steps/tqAddDriver";
import TqPanelLoader from "./components/tqPanelComponents/tqPanelLoader";
import TqPanel from "./steps/tqPanel";
import QuoteStep from "./enums/QuoteStep";
import useAppStateStore from "../../shared/store/AppStateStore";
import PageContentStack from "../../shared/components/PageContentStack";

const stepComponents = {
  [QuoteStep.TQ1]: Tq1,
  [QuoteStep.TQ2]: Tq2,
  [QuoteStep.TQ3]: Tq3,
  [QuoteStep.TQ4]: Tq4,
  [QuoteStep.TQ5]: Tq5,
  [QuoteStep.TQ6]: Tq6,
  [QuoteStep.TQ_CLAIM]: TqClaim,
  [QuoteStep.TQ_ADD_DRIVER]: TqAddDriver,
  [QuoteStep.TQ_PANEL_LOADER]: TqPanelLoader,
  [QuoteStep.TQ_PANEL]: TqPanel,
};

const AllQuoteSteps = () => {
  const currentStep = useAppStateStore((state) => state.currentStep);
  const StepComponent = stepComponents[currentStep] || null;
  if (!StepComponent) return null;
  if (currentStep === QuoteStep.TQ_PANEL) return <StepComponent />;

  return (
    <PageContentStack className="tw-gap-0">
      <StepComponent />
    </PageContentStack>
  );
};

export default AllQuoteSteps;
